<template>
  <div class="min-h-screen bg-white flex flex-col">
    <TrustBar />
    <main class="flex-1 pt-[120px] pb-12">
      <div class="max-w-4xl mx-auto px-4">
        <h1 class="text-3xl font-bold text-gray-900 mb-6">Déclaration d'Accessibilité</h1>

        <div class="prose prose-gray max-w-none">
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Notre engagement</h2>
            <p class="text-gray-600">Nous nous engageons à rendre notre site accessible à tous les utilisateurs, quel que soit leur handicap ou leur situation technologique.</p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Conformité</h2>
            <p class="text-gray-600 mb-4">Notre site s'efforce de respecter les normes d'accessibilité suivantes :</p>
            <ul class="list-disc list-inside text-gray-600 space-y-2">
              <li>WCAG 2.1 (Web Content Accessibility Guidelines)</li>
              <li>Niveau AA recommandé</li>
              <li>Directives RGAA (Référentiel Général d'Amélioration de l'Accessibilité)</li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Fonctionnalités d'accessibilité</h2>

            <div class="space-y-4">
              <div class="bg-gray-50 rounded-2xl p-6">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">Navigation</h3>
                <p class="text-gray-600">Navigation au clavier, structure cohérente, liens descriptifs et plan du site clair.</p>
              </div>

              <div class="bg-gray-50 rounded-2xl p-6">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">Contenu</h3>
                <p class="text-gray-600">Contraste suffisant, tailles de police ajustables, textes alternatifs pour les images.</p>
              </div>

              <div class="bg-gray-50 rounded-2xl p-6">
                <h3 class="text-xl font-semibold text-gray-900 mb-2">Compatibilité</h3>
                <p class="text-gray-600">Compatible avec les technologies d'assistance (lecteurs d'écran, agrandisseurs d'écran).</p>
              </div>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Améliorations continues</h2>
            <p class="text-gray-600">Nous travaillons régulièrement à l'amélioration de l'accessibilité de notre site. Vos retours sont précieux.</p>
          </section>

          <section>
            <h2 class="text-2xl font-semibold text-gray-900 mb-4">Signaler un problème</h2>
            <p class="text-gray-600 mb-4">Si vous rencontrez des difficultés d'accès, n'hésitez pas à nous contacter :</p>
            <ul class="list-disc list-inside text-gray-600 space-y-2">
              <li>Via notre formulaire de contact</li>
              <li>En précisant la page et le type de problème rencontré</li>
            </ul>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue';
</script>
